import { useState, useCallback } from 'react';
import { d204Api, FD140 } from '../../../services/d204Api';

export function useLookupNames() {
  const [names, setNames] = useState<Record<string, string>>({});

  /** Batch-resolve all lookup names for master */
  const resolveAllNames = useCallback(async (data: Partial<FD140>) => {
    const entries: [string, string, string][] = [
      ['processor', 'company', data.fd140_10 || ''],        // 加工廠
      ['warehouse', 'warehouse', data.fd140_13 || ''],       // 庫位
      ['currency', 'currency', data.fd140_36 || ''],         // 幣別
      ['entryPerson', 'employee', data.fd140_43 || ''],      // 建檔人員
    ];
    const results = await Promise.all(
      entries.map(([key, type, code]) =>
        d204Api.lookupName(type, code).then(name => [key, name] as [string, string])
      )
    );
    setNames(prev => {
      const next = { ...prev };
      for (const [key, name] of results) next[key] = name;
      return next;
    });
  }, []);

  /** Resolve a single lookup name (for onBlur events) */
  const resolveSingleName = useCallback(async (nameKey: string, type: string, code: string) => {
    const name = await d204Api.lookupName(type, code);
    setNames(prev => ({ ...prev, [nameKey]: name }));
  }, []);

  /** Clear all cached names */
  const clearNames = useCallback(() => {
    setNames({});
  }, []);

  return { names, setNames, resolveAllNames, resolveSingleName, clearNames };
}
